module.exports = __webpack_public_path__ + "static/media/bg2_sm.ef6b40c0.webp";